import React from "react";
import { ProcessorsEnum } from "../../shared/constants/ProcessorEnum";
import { useCheckoutContext } from "../../context/useCheckoutContext";
import { CheckoutTransferAccendo } from "../CheckoutTransferAccendo/CheckoutTransferAccendo";
import { CheckoutRecurrentDebit } from "../CheckoutRecurrentDebit/CheckoutRecurrentDebit";
export var CheckoutTransferSubscription = function () {
    var transferSubscriptionProcessor = useCheckoutContext().transferSubscriptionProcessor;
    var renderTransferSection = function () {
        switch (transferSubscriptionProcessor) {
            case ProcessorsEnum.ACCENDO:
                return React.createElement(CheckoutTransferAccendo, null);
            case ProcessorsEnum.CONFRONTA:
                return React.createElement(CheckoutRecurrentDebit, null);
            default:
                return React.createElement("div", null);
        }
    };
    return React.createElement(React.Fragment, null, renderTransferSection());
};
